export default "__VITE_ASSET__COL09gLy__"